import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AbbrComponent } from "./abbr/abbr.component";
import { HowToComponent } from "./howto/howto.component";
import { HelpCenterComponent } from "./help-center.component";
import { MaterialModule } from "../../material/material.module";
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

const COMPONENTS = [
	AbbrComponent,
	HowToComponent,
	HelpCenterComponent
];

@NgModule({
	declarations: COMPONENTS,
	imports: [
		CommonModule,
		MaterialModule,
		MatTabsModule,
		TranslateModule
	],
	exports: COMPONENTS
})
export class HelpCenterModule { }

